import BaseApi from './BaseApi';

class AuthApi extends BaseApi {
  constructor(props) {
    super(props);

    this.API_NAME = 'users';
  }

  async login(email, password) {
    return this.postRequest('login', { data: { email, password } });
  }

  async loginByToken() {
    const { user } = await this.getRequest('profile');

    return user;
  }

  async logout() {
    return this.postRequest('logout');
  }
}

export default new AuthApi();



// WEBPACK FOOTER //
// ./src/api/AuthApi.js